import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from "redux";
import {PropTypes} from "prop-types";

import ScholarFacet from "../../../components/Scholar/front/list/facet";
import ScholarItem from "../../../components/scholar/front/list/Scholaritem";
import ScholarOrder from "../../../components/Scholar/front/list/order";
import Loading from "../../../components/etc/loading";

import * as Actions from "../../../store/modules/scholars";

import * as func from "../../../utils/functions";
import * as hooks from "../../../utils/hooks";
import ReactPaginate from "react-paginate";
import FrontFooter from "../../../components/etc/footer";
import {objectToQueryString, pushUrl} from "../../../utils/functions";
import {BASE_PATH} from "../../../wpconfig";

class Scholars extends Component {
	constructor(props) {
		super(props);
		this.state = {
			isInit: false,
			action : 'scholars'
		}
	}

	componentDidMount() {
		hooks.menuHook(this, this.state.action);
		if (location.search.substring(1)) {
			this.props.dataActions.setScholars({'param': func.parseParams(location.search.substring(1))});
		} else {
			this.facetReset()
		}
		// 이해 안됨.
		setTimeout(() => {
			this.getList();
		}, 0);
	}

	componentWillUnmount() {
		this.setState = (state, callback) => {
			return;
		}
	}

	facetReset() {
		let param = this.props.param;
		Object.keys(this.props.param).map((key, i) => {
			if (!param[key] || param[key].length <= 0)
				return;
			if (key === 'record_per_page' || key === 'order' || key === 'order_by') {
			} else if (key === 'current_page') {
				param[key] = 1;
			} else if (Array.isArray(param[key])) {
				param[key] = [];
			} else {
				param[key] = "";
			}
		});

		const {dataActions} = this.props;
		dataActions.setScholars({"param": param});
	}

	getList() {
		func.getData(this.state.action, this.props.param).then((response) => {
			this.setState({
				isInit: true,
			})
			this.props.dataActions.setScholars(response);
		});
	}

	handlePageClick = (page) => {
		const paged = page.selected + 1;

		let param = this.props.param;
		param['current_page'] = paged;

		const {dataActions} = this.props;
		dataActions.setScholars({"param": param});

		setTimeout(() => {
			func.getData(this.state.action, param).then((response) => {
				this.props.dataActions.setScholars(response);

				const url = objectToQueryString(this.props.param);
				pushUrl('검색', BASE_PATH + this.state.action +'/?' + url, this.props.param);

				func.scrollMove();
			});
		}, 0);
	}

	render() {
		const {records} = this.props;
		const {isInit} = this.state;
		const {setDetail} = this;

		return (
			<div className="contents-group">
				<ScholarFacet/>
				<div className="center-group">
					{!isInit && <Loading/>}
					{isInit &&
					<div className="">
						<div className="d-flex justify-content-between align-items-center">
							<ScholarOrder/>
						</div>
						<>
							<div className="mt-3">
								<div>
									<div className="line-list-group">
										{isInit && records.length <= 0 &&
										<div className="search-none">
											<div className="icon icon-search-none"/>
											<div className="desc">검색 결과가 없습니다.</div>
										</div>}
										{records.map((record, index) => {
											return (
												<ScholarItem key={index} pSetDetail={setDetail} record={record}
															 refreshList={() => this.getList()}
												/>
											)
										})}
									</div>
								</div>
							</div>
							{this.props.totalPage > 1 &&
							<div className="mt-4">
								<div>
									<div className="paging-wrap">
										<ReactPaginate
											forcePage={Number(this.props.param.current_page) - 1}
											pageCount={this.props.totalPage}
											marginPagesDisplayed={2}
											pageRangeDisplayed={10}
											onPageChange={this.handlePageClick}
											containerClassName={'pagination'}
											activeClassName={'active'}
											pageClassName={'page-item'}
											pageLinkClassName={'page-link'}
											previousClassName={'page-item page-item-prev'}
											previousLinkClassName={'page-link'}
											nextClassName={'page-item page-item-next'}
											nextLinkClassName={'page-link'}
										/>
									</div>
								</div>
							</div>
							}
						</>
					</div>
					}
				</div>
				<FrontFooter
					param={this.props.param}
					facet={this.props.facet}
					dataActions={this.props.dataActions}/>
			</div>
		)
	}
}

export default connect(
	(state) => ({
		param: state.scholars.param ? state.scholars.param : {},
		records: state.scholars.records ? state.scholars.records : [],
		facet: state.scholars.facet ? state.scholars.facet : {},
		totalRecords: state.scholars.totalRecords ? state.scholars.totalRecords : 0,
		totalPage: state.scholars.totalPage ? state.scholars.totalPage : 0,
	}),
	(dispatch) => ({
		dataActions: bindActionCreators(Actions, dispatch)
	}),
)(Scholars)

Scholars.propTypes = {
	param: PropTypes.object,
	records: PropTypes.array,
	facet: PropTypes.object,
	totalRecords: PropTypes.number,
	totalPage: PropTypes.number,
};
